import { render, staticRenderFns } from "./Hijos.vue?vue&type=template&id=d3b7a3aa&"
import script from "./Hijos.vue?vue&type=script&lang=js&"
export * from "./Hijos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports